import React from 'react'

import { MessengerUtilityItems } from '@lyrahealth-inc/ui-core-crossplatform/src/molecules/messengerUtilities/MessengerUtilities'

import MessengerUtilityItemDrafts from './items/MessengerUtilityItemDrafts'
import MessengerUtilityItemTemplates from './items/MessengerUtilityItemTemplates'
import { InsertMessageOptions } from '../../BaseChat'
import MessengerUtilityItemSmartSuggestions from './items/smartSuggestions/MessengerUtilityItemSmartSuggestions'

type MessengerUtilityItemContentProps = {
  selectedItem: MessengerUtilityItems
  onConversationPressed: ({ clientId, externallySelected }: { clientId: string; externallySelected?: boolean }) => void
  onSendPressed?: () => void
  insertMessage: (message: string, opts?: InsertMessageOptions) => void
}

const MessengerUtilityItemContent: React.FC<MessengerUtilityItemContentProps> = ({
  selectedItem,
  onConversationPressed,
  onSendPressed = () => {},
  insertMessage,
}) => {
  switch (selectedItem) {
    case MessengerUtilityItems.DRAFTS:
      return <MessengerUtilityItemDrafts onConversationPressed={onConversationPressed} />
    case MessengerUtilityItems.TEMPLATES:
      return <MessengerUtilityItemTemplates onSendPressed={onSendPressed} insertMessage={insertMessage} />
    case MessengerUtilityItems.SMART_SUGGESTIONS:
      return <MessengerUtilityItemSmartSuggestions onConversationPressed={onConversationPressed} />
  }
}

export default MessengerUtilityItemContent
